
let config = {};

export const loadConfig = () => {
    return fetch('/config.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load config');
        }
        return response.json();
      })
      .then(data => {
        config = data;
      });
  };
  // Export the loadConfig function
  export const getConfig = () => config;